<div class=" asset profile-authentication-area ptb-100">
    <div class="container">
        <div class="row ">
            <div class="col-lg-6 col-md-12">

                <div class="get-instant-courses-image"><img src="assets/img/picturecfa.jpeg" alt="image">
                </div>
            </div>
            <div class="col-lg-6 col-md-12" style="margin-bottom:12px">
                <div class="login-form">
                    <h2 class="level-title">{{workspace?.labels[workspace?.id]}}</h2>
                    <form [formGroup]="loginForm" ngNativeValidate (ngSubmit)="onSubmit()">
                        <div class="form-group">
                            <label>Adresse Email</label>
                            <input required formControlName="email" name="email" type="text" class="form-control">
                        </div>
                        <div class="form-group">
                            <label>Mot de passe</label>
                            <input autocomplete="on" required formControlName="password" name="password" type="password"
                                class="form-control">
                        </div>
                        <div class="row align-items-center">
                            <div style="cursor:pointer" class="col-lg-6 col-md-6 col-sm-6  col-6 lost-your-password-wrap"
                                (click)="changeWorkSpace()">
                                <a class="lost-your-password">{{workspace?.labels[workspace?.nextId]}}</a>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-6 col-6 lost-your-password-wrap">
                                <a [routerLink]="'/reset-password'" class="lost-your-password">Mot de passe
                                    perdu</a>
                            </div>
                        </div>
                        <div *ngIf="state?.errorMessage" style="color:red;margin-top:12px">
                            {{state.errorMessage}}
                        </div>
                        <button type="submit" [disabled]="showSpinner" class="btn btn-success" type="submit">Je
                            me connecte <span *ngIf="showSpinner" class="spinner-border spinner"></span></button>
                    </form>
                </div>
            </div>


        </div>
        <div>
        </div>
    </div>
</div>